import React, {
  ForwardRefRenderFunction,
  useImperativeHandle,
  useRef,
} from 'react';
import BillRow from './BillRow';
import { Button, Input } from 'antd';
import Form from '@sezenta/antd-schema-form';
import { BillRow2 } from './BillRow2';
import { BillEditModalInstance } from './BillEditModal';

export type BillTableInstance = {};

type Props = {};
const borderStyles = 'border border-gray-300 border-solid';
const BillTable: ForwardRefRenderFunction<BillTableInstance, Props> = (
  props,
  ref,
) => {
  useImperativeHandle(ref, () => ({}), []);

  return (
    <div>
      <table width="100%" className={`border-collapse`}>
        <thead>
          <tr>
            <th className={borderStyles}>Item</th>
            <th className={borderStyles}>Account</th>
            <th className={borderStyles}>Quantity</th>
            <th className={borderStyles}>Rate</th>
            <th className={borderStyles}>Tax</th>
            <th className={borderStyles}>Discount</th>
            <th className={borderStyles}>Amount</th>
            <th className={borderStyles}></th>
          </tr>
        </thead>
        <tbody>
          <Form.List name={'items'}>
            {(subFields, subOpt) => (
              <>
                {subFields.map((field, i) => (
                  <BillRow2
                    key={i}
                    name={field.name}
                    onDelete={() => subOpt.remove(i)}
                  />
                ))}
                <Button onClick={() => subOpt.add()}>Add Item</Button>
              </>
            )}
          </Form.List>
        </tbody>
      </table>
    </div>
  );
};

export const useBillTable = () => useRef<BillTableInstance>(null);

export default React.forwardRef<BillTableInstance, Props>(BillTable);
